export class FormData {
    public id: number;
    public instanceId: number;
    public name: string;
    public label: string;
    public pageId: number;
    public prevPageId: number;
    public nextPageId: number;
    public pageName: string;
    public pageLabel: string;
    public currentPageOrder: number;
    public totalPages: number;
    public formInstanceItem: Array<any>;
    public multipleLanguage: String;
    public userLanguage: String;

    constructor (data) {
        this.id = data.formId;
        this.instanceId = data.formInstanceId;
        this.name = data.formName;
        this.label = data.formLabel;
        this.pageId = data.currentpageid;
        this.prevPageId = data.prevpageid;
        this.nextPageId = data.nextpageid;
        this.pageName = data.pageName;
        this.pageLabel = data.pageLabel;
        this.currentPageOrder = data.currentPageOrder;
        this.totalPages = data.totalPages;
        this.formInstanceItem = data.formInstanceItem;
        this.multipleLanguage = data.multipleLanguage;
        this.userLanguage = data.userLanguage;
    }

    getFormId () {
        return this.id;
    }

    getFormInstance () {
        return this.instanceId;
    }

    getFormInstanceItem () {
        return this.getFormInstanceItem;
    }

    updateFormData (data) {
        this.pageId = data.currentpageid;
        this.prevPageId = data.prevpageid;
        this.nextPageId = data.nextpageid;
        this.pageName = data.pageName;
        this.totalPages = data.totalPages;
        this.pageLabel = data.pageLabel;
        this.currentPageOrder = data.currentPageOrder;
        this.formInstanceItem = data.formInstanceItem;
    }
}
